var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoracaoLaranja(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8267 3.52061C12.3302 -0.724874 7.46657 1.17311 7.02229 3.29585C6.41434 1.04824 1.66764 -0.624981 0.217909 3.52061C-1.3955 8.14069 6.46111 12.2863 7.02229 12.9606C7.58348 12.4111 15.4401 8.06577 13.8267 3.52061Z",
    fill: "#5AB2AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoracaoLaranja);
export default __webpack_public_path__ + "static/media/CoracaoLaranja.57f028146f29f9bbadd0978956dd16a1.svg";
export { ForwardRef as ReactComponent };